<template>
    <div>
        <!-- filter -->
        <v-row class="mt-1">
            <v-col cols="3">
                <v-autocomplete 
                    v-model="entityIds"
                    :items="allEntities"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.doctor-name')"
                    outlined
                    dense
                    :loading="loading"
                    :disabled="loading"
                    hide-details
                    multiple
                    clearable
                />
            </v-col>

            <v-col cols="3">
                <v-autocomplete 
                    v-model="employeeIds"
                    :items="medicalRepsBrief"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.employee')"
                    outlined
                    dense
                    :loading="loading"
                    :disabled="loading"
                    hide-details
                    multiple
                    clearable
                />
            </v-col>

            <v-col>
                <v-btn @click="fetchUnavailableMaterial()" :loading="loading" color="success" small class="text-none">
                    {{$t('search')}} 
                </v-btn>

                <v-btn
                    class="mx-1"
                    @click="clearFilter();"
                    :disabled="loading"
                    color="alert-color white--text"
                    small
                >
                    {{$t('reset')}}
                </v-btn>
            </v-col>
        </v-row>

        <bee-handy-table
            ref="table"
            :headers="headers"
            :items="items"
            dense
            hide-default-footer
            :items-per-page="-1"
            :shown-rows-text="$t('shown-rows')"
            class="mt-2"
            :height="$vuetify.breakpoint.height - 150"
            :loading="loading"
            zebra
        ></bee-handy-table>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
export default {
    data() {
        return {
            loading: false,
            items: [],
            allEntities: [],
            entityIds: [],
            employeeIds: []
        }
    },
    computed: {
        ...mapState({
            materials: state => state.materials.materials,
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief
        }),
        
        ...mapGetters({
            getMaterialById: 'materials/getMaterialById'
        }),

        headers() {
            return [
                {
                    text: this.$t('headers.date'),
                    name: 'visitdate',
                    value: 'visitdate',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                },
                {
                    text: this.$t('headers.doctor-name'),
                    name: 'entityId',
                    value: 'entityId',
                    setValueExpr: val => this.allEntities.find(c => c.id === val)?.name || ''
                },
                {
                    text: this.$t('headers.item'),
                    name: 'materialIds',
                    value: 'materialIds',
                    setValueExpr: val => val.length ? val.map(id => this.getMaterialById(id)?.name || '').join(',  ') : ''
                }
            ]
        }
    },

    methods: {
        fetchUnavailableMaterial() {
            this.loading = true
            return this.$store.dispatch('visits/fetchUnavailableMaterial', { 
                customerIds: this.entityIds, 
                employeeIds: this.employeeIds
            }).then((data) => {
                this.items = data
            }).finally(() => {
                this.loading = false
            })
        },

        clearFilter () {
            this.entityIds = []
            this.employeeIds = []
            this.items = []
        }
    },

    created () {
        Promise.all([
            !this.materials.length ? this.$requestStack.setRequest({
                key: 'materials/fetchAll',
                promise: this.$store.dispatch('materials/fetchAll', true)
            }) : this.$requestStack.getRequest('materials/fetchAll').promise,

            !this.medicalRepsBrief.length 
                ? this.$requestStack.setRequest({
                    key: 'medicalreps/fetchAllBrief',
                    promise:  this.$store.dispatch('medicalreps/fetchAllBrief', true)
                }) 
                : this.$requestStack.getRequest('medicalreps/fetchAllBrief').promise,

            this.$store.dispatch('entities/fetchByFilter', {
                regionIds: [],
                workloadIds: [],
                nonDeleted: true,
                OrderByName: true,
                WithVisitsCount: false
            })
        ]).then((data) => {
            console.log(data[2].data)
            this.allEntities = data[2].data
            console.log(this.allEntities)
        })
    }
}
</script>
